import { render } from "./ConfirmationDialogue.vue?vue&type=template&id=a273f144"
import script from "./ConfirmationDialogue.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__